// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2LnjJ","list":"PatternAutocomplete_list__2Qx7p"};